import LegalLinks from './legalLinks';

export default LegalLinks;